import styles from "./Footer.module.scss";

const Footer = () => {
    return (
        <footer className={styles.footer}>
            <div className={styles.contact}></div>
        </footer>
    );
};

export default Footer;
